import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "react-bootstrap";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Dialog header="Accesso non autorizzato" visible={true} modal onHide={() => navigate("/")}>
      <p>Devi fare login per accedere alla pagina</p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button className="button" onClick={() => navigate("/")}>
          Vai al login
        </Button>
      </div>
    </Dialog>
  );
};

export default Unauthorized;
